import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { spaceProp, getColorToken, getVariantToken, getSizeToken } from '@koaly/mixins';
import React from 'react';
import styled, { css } from 'styled-components';

const StyledBox = styled.div `
  ${({ spacing }) => spacing && spaceProp(spacing, 'padding')};
  ${({ spacingV }) => spacingV && spaceProp(spacingV, ['paddingTop', 'paddingBottom'])};
  ${({ spacingH }) => spacingH && spaceProp(spacingH, ['paddingLeft', 'paddingRight'])};
  ${({ spaceAfter }) => spaceAfter && spaceProp(spaceAfter, 'marginBottom')};
  ${({ backgroundColor }) => backgroundColor && `background-color: ${backgroundColor}`};
  ${({ backgroundToken }) => backgroundToken && `background-color: ${getColorToken('600', backgroundToken)}`};
  ${({ align }) => align && `text-align: ${align}`};
  ${({ border }) => border && css `border: 1px solid ${getVariantToken('box', 'borderColor')}`};
  ${({ elevation, theme }) => elevation && css `
    box-shadow: ${theme.elevations[elevation]};
  `};
  ${({ borderRadius }) => borderRadius && css `
    border-radius: ${getSizeToken('box', 'borderRadius')};
  `}
`;
const Box = React.forwardRef((_a, ref) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (React.createElement(StyledBox, Object.assign({ ref: ref }, props), children));
});

export { Box };
//# sourceMappingURL=Box.js.map
